<template>
  <q-modal
      v-model="opened"
      :noBackdropDismiss="true"
      position="bottom"
      @hide="stopAll"
      @show="hideLoading"
      content-classes="panel mediator"
  >
    <div class="panel-header">
      <q-resize-observable @resize="onResize1" />
      <div class="panel-title">
        <span>
          {{title}}
        </span>
        <small class="text-grey-6">
          {{fileName}}, {{fileSize | formatSize}}
        </small>
        <span class="text-warning">
          {{groupMessage}}
        </span>
      </div>
      <q-btn @click="doCancel" title="Отменить" color="primary" icon="clear" small round flat />
      <q-btn
          @click="doSave"
          :disabled="!name"
          color="positive"
          icon="done"
          small
          round
          flat
          title="Вставить"
      />
    </div>
    <div class="panel-body">
      <div>
        <q-resize-observable @resize="onResize2" />
        <q-field
          :error="$v.name.$error"
          :error-label="$v.name | errorLabel"
        >
          <q-input float-label="Название" v-model.trim="name" :suffix="reqType==='file'?ext:''"/>
        </q-field>
        <div class="row justify-between">
          <q-btn
              icon="crop_rotate"
              v-if="editableFormat"
              @click="doCropRotate"
              color="primary"
              small
              round
              flat
              title="Обрезать/повернуть"
          />
        </div>
      </div>
      <pic-resize
        v-if="(this.file && file.type.indexOf('image') === 0) && opened"
        v-model="blob"
        :maxHeight="picMaxHeight"
        :url="url"
        :picIniSize="fileSize"
        :editableFormat="editableFormat"
        :maxQuality="maxQuality"
      />
      <video
          v-if="this.file && file.type.indexOf('video') === 0"
          :style="{ maxHeight: maxHeight }"
          :src="url"
          controls
          id="v"
      >
      </video>
      <audio
          v-if="this.file && file.type.indexOf('audio') === 0"
          :src="url"
          controls
          id="a"
      >
      </audio>
    </div>
    <slim-cropper :options="slimOptions" ref="slim" :data="file" v-if="slimShow"/>
  </q-modal>
</template>
<style scoped>
  video, audio {
    max-width: 100%;
  }
</style>
<script type="text/babel">

import { required } from 'vuelidate/lib/validators';
import { withParams } from 'vuelidate/lib';
import { Loading } from 'quasar';
import PicResize from 'components/pic-resize.vue';
import SlimCropper from 'components/slim.vue';

export default {
  name: 'mediaInserter',
  components: {
    PicResize,
    SlimCropper,
  },
  props: {
  },
  data() {
    return {
      maxQuality: 101, // 101 means picture not changed
      file: null,
      fileSize: null,
      blob: null,
      fileName: '',
      name: '',
      ext: '',
      url: '',
      opened: false,
      slimShow: false,
      height1: 0,
      height2: 0,
      left: 0, // how much medias left
      reqType: null, // required media type
      slimOptions: {
        instantEdit: true,
        push: true,
        didCancel: this.slimCancel,
        service: this.slimService,
        serviceFormat: 'file',
        buttonConfirmLabel: 'Сохранить',
        buttonCancelLabel: 'Отменить',
        buttonConfirmTitle: 'Сохранить',
        buttonCancelTitle: 'Отменить',
        buttonRotateTitle: 'Повернуть',
      },
    };
  },
  validations: {
    name: {
      required: withParams({ message: 'Введите название' }, required),
    },
  },
  computed: {
    editableFormat() { // if editable picture (new .jpeg, .bmp or .png media) return image format else return null
      const f = this.file && this.file.type && this.file.type.split('/')[1];
      if (f === 'jpeg' || f === 'png' || f === 'bmp' || f === 'gif') {
        return f;
      }
      return null;
    },
    picMaxHeight() {
      return (0.8 * this.$store.state.pageHeight) - this.height1 - this.height2 - 35;
    },
    maxHeight() {
      return `${this.picMaxHeight}px`;
    },
    groupMessage() {
      return this.left ? `[и еще ${this.left}]` : '';
    },
    title() {
      if (this.reqType === 'image') {
        return 'Вставить рисунок';
      } else if (this.reqType === 'video') {
        return 'Вставить видео';
      } else if (this.reqType === 'audio') {
        return 'Вставить аудио';
      }
      return 'Вставить ссылку на файл';
    },
  },
  watch: {
  },
  methods: {
    doCropRotate() {
      console.log('doCropRotate media');
      this.slimShow = true;
    },
    onResize1(size) {
      // console.log('onResize1', size.height);
      this.height1 = size.height;
    },
    onResize2(size) {
      // console.log('onResize2', size.height);
      this.height2 = size.height;
    },
    init(media, left = 0, reqType) {
      Loading.show();
      this.blob = null;
      this.maxQuality = 101; // unchanged picture
      console.log('MEDIA-INSERTER INIT reqType, media', reqType, media);
      this.left = left;
      if (reqType) { // change this.reqType if provided
        this.reqType = reqType;
      }
      if (media.file) {
        this.file = media.file;
        this.fileName = media.file.name;
        const i = this.fileName.lastIndexOf('.');
        if (i > -1) {
          this.ext = this.fileName.substr(i);
          this.name = this.fileName.substr(0, i);
        } else {
          this.ext = '';
          this.name = this.fileName;
        }
        this.fileSize = media.file.size;
        this.url = URL.createObjectURL(media.file);
        this.opened = true;
      } else {
        Loading.hide();
        console.log('ERROR -- No correct media provided!');
      }
    },
    hideLoading() {
      Loading.hide();
    },
    stopAll() {
      console.log('****************** STOP ALL ****************************');
      this.$v.name.$reset();
      const a = document.getElementById('a');
      const v = document.getElementById('v');
      if (a) a.pause();
      if (v) v.pause();
      if (this.left) {
        this.$emit('doNext'); // process next mediaFile
      }
    },
    download(e) {
      console.log(e);
    },
    slimCancel() {
      console.log('slimCancel');
      this.slimShow = false;
    },
    slimService(formdata, progress, success, failure, slim) {
      console.log('slimService');
      console.log('rotation', slim._data.actions.rotation);
      console.log('input', slim._data.input.height, slim._data.input.width);
      console.log('output', slim._data.output.height, slim._data.output.width);
      const changed = () => {
        if (slim._data.actions.rotation > 0) return true;
        if (Math.abs(slim._data.input.height - slim._data.output.height) > 3) return true;
        if (Math.abs(slim._data.input.width - slim._data.output.width) > 3) return true;
        return false;
      };
      if (changed()) {
        this.file = formdata[0];
        console.log('SLIM SERVICE CHANGED file', this.file);
        this.url = URL.createObjectURL(this.file);
        this.fileSize = this.file.size;
        this.maxQuality = 100; // picture changed
      } else {
        console.log('********** picture not changed ************');
      }
      this.slimShow = false;
    },
    doCancel() {
      this.opened = false;
    },
    doSave() {
      const it = this;
      this.$v.name.$touch();
      if (this.$v.name.$invalid) {
        this.$store.commit('pushError', {
          error: 'Ошибка!',
          message: 'Неверный ввод',
        });
        return false;
      }
      it.$utils.digest(it.blob ? it.blob : it.file)
        .then(digest => this.$store.dispatch('wiki/saveMedia', {
          _id: `x:${digest}`,
          _attachments: {
            media: {
              content_type: it.blob ? it.blob.type : it.file.type,
              data: it.blob ? it.blob : it.file,
            },
          },
        }))
        .then((id) => {
          this.opened = false;
          it.$emit('mediaSaved', {
            id,
            file_size: it.blob ? it.blob.size : it.fileSize,
            name: it.name,
            ext: it.blob ? `.${it.blob.type.split('/')[1]}` : it.ext,
            reqType: it.reqType,
          });
        })
        .catch((err) => {
          console.log('err', err);
          it.$store.commit('pushError', err);
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/media-inserter.vue